import { render, staticRenderFns } from "./background-video-slider-v2.vue?vue&type=template&id=5e7b0568&scoped=true&"
import script from "./background-video-slider-v2.vue?vue&type=script&lang=js&"
export * from "./background-video-slider-v2.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=5e7b0568&scoped=true&lang=css&"
import style1 from "./background-video-slider-v2.vue?vue&type=style&index=1&id=5e7b0568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7b0568",
  null
  
)

export default component.exports